import { Grid2 } from '@mui/material'
import React from 'react'
import i18n from 'simple-react-i18n'
import { useParams } from 'react-router'
import useTitle from 'utils/customHook/useTitle'
import { shallowEqual, useSelector } from 'react-redux'

const TerritoryA3PDetailApp = ({}) => {
    const params = useParams()

    const {
        managementUnits,
    } = useSelector(store => ({
        managementUnits: store.ManagementUnitReducer.managementUnits,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.steering,
        href: 'territory',
    }, {
        title: i18n.AUPSynthesis,
        href: 'territory/A3P',
    }, {
        title: managementUnits.find(m => m.managementCode === parseInt(params.id)).name,
        href: `territory/A3P/${params.id}`,
    }], [])

    return (
        <Grid2 container size={12} spacing={1.5} sx={{ padding: 2 }}>
            {/* TODO */}
        </Grid2>
    )
}

export default TerritoryA3PDetailApp